/**
 * AllAll：POST /v1/chat/completions
 * model 固定 gemini-3-pro-image-preview，多模态 user 消息（可配置 text + 上传的 base64 图）
 * 用于去水印 / 去背景等场景，通过 mode 切换默认提示词，也可用 text 完全覆盖。
 */

var MODEL = 'gemini-3-pro-image-preview'
var MAX_TOKENS = 4096

/** 去水印默认提示（与产品约定文案一致） */
export var DEFAULT_PROMPT_WATERMARK =
  '请对该图片进行无痕迹去水印处理：1. 识别并清除图片中所有可见水印（含显性文字 / 图形水印、隐性半透明水印、重复水印图案）；2. 基于水印周边的背景纹理，智能补全水印覆盖区域的像素，保证补全部分与原图融合自然，无边界、无模糊、无失真；3. 保留图片原始的分辨率、色彩饱和度、光影层次和细节纹理，整体画面无修图痕迹，处理后图片可直接使用。'

/** 去背景默认提示（可与去水印切换；也可由调用方传入 text 覆盖） */
export var DEFAULT_PROMPT_REMOVE_BACKGROUND =
  '请对该图片进行专业去背景处理：1. 精确识别主体轮廓与背景区域；2. 完整保留主体边缘细节（发丝、半透明物体等），去除背景；3. 输出保留透明通道的效果（如接口支持），保证主体边缘自然无锯齿、无白边；4. 保持原图分辨率与主体色彩、光影层次不变，整体无修图痕迹。'

export var GEMINI_IMAGE_EDIT_MODE = {
  WATERMARK: 'watermark',
  REMOVE_BACKGROUND: 'remove_background'
}

var PROMPTS_BY_MODE = {}
PROMPTS_BY_MODE[GEMINI_IMAGE_EDIT_MODE.WATERMARK] = DEFAULT_PROMPT_WATERMARK
PROMPTS_BY_MODE[GEMINI_IMAGE_EDIT_MODE.REMOVE_BACKGROUND] = DEFAULT_PROMPT_REMOVE_BACKGROUND

/**
 * 构建请求体（除 text / 图片 url 外参数固定）
 * @param {Object} params
 * @param {string} params.imageUrl - data:image/png;base64,... 或 http(s) 图片地址
 * @param {string} [params.mode] - 'watermark' | 'remove_background'，与 GEMINI_IMAGE_EDIT_MODE 一致
 * @param {string} [params.text] - 自定义提示词；传入则忽略 mode 默认文案
 * @returns {Object} POST body
 */
export function buildBody(params) {
  var imageUrl = (params.imageUrl || params.image_url || '').toString().trim()
  if (!imageUrl) {
    throw new Error('imageUrl 必填（如 data:image/png;base64,...）')
  }
  var customText = params.text != null ? String(params.text).trim() : ''
  var mode = (params.mode || params.editMode || GEMINI_IMAGE_EDIT_MODE.WATERMARK).toString()
  var promptText = customText || PROMPTS_BY_MODE[mode] || DEFAULT_PROMPT_WATERMARK

  return {
    max_tokens: MAX_TOKENS,
    model: MODEL,
    messages: [
      {
        role: 'user',
        content: [
          { type: 'text', text: promptText },
          {
            type: 'image_url',
            image_url: { url: imageUrl }
          }
        ]
      }
    ]
  }
}

/**
 * 解析 Chat Completions 响应：汇总文本与可能的 image_url
 * @param {Object} res - axios 完整响应（含 data）
 */
export function parseResponse(res) {
  var data = res && res.data
  var texts = []
  var imageUrls = []
  if (!data || !Array.isArray(data.choices) || !data.choices.length) {
    return { data: data, text: '', imageUrls: imageUrls }
  }
  var msg = (data.choices[0] && data.choices[0].message) || {}
  var content = msg.content
  if (typeof content === 'string') {
    if (content) texts.push(content)
    var md = content.match(/!\[[^\]]*\]\(([^)]+)\)/)
    if (md && md[1]) imageUrls.push(md[1])
  } else if (Array.isArray(content)) {
    content.forEach(function (part) {
      if (!part || typeof part !== 'object') return
      if (part.type === 'text' && part.text) texts.push(String(part.text))
      if (part.type === 'image_url' && part.image_url && part.image_url.url) {
        imageUrls.push(String(part.image_url.url))
      }
    })
  }
  return {
    data: data,
    text: texts.join('\n'),
    imageUrls: imageUrls
  }
}
